// src/hooks/useMergeActiveSale.ts
import { showToast } from "@/src/components/toast/showToast";
import { useCallback } from "react";
import { fetchActiveSale } from "../api/action/sale";
import useCartStore from "../store/useCartStore";

export const useMergeActiveSale = () => {
  const addCard = useCartStore((s) => s.addCard);
  const cart = useCartStore((s) => s.cart);

  return useCallback(async () => {
    let res;
    try {
      res = await fetchActiveSale(); // ممکن است 204 باشد
    } catch {
      return; // خطا = بنا را بر نبود سفارش می‌گذاریم
    }
    if (res.status === 204) return; // هیچ سفارشی نبود

    const sale = res.data;
    if (!sale?.sale_products?.length) return;

    const added: string[] = [];

    sale.sale_products.forEach((row: any) => {
      if (!cart.some((c) => c.ProductIdentityId === row.ProductIdentityId)) {
        addCard({
          ProductId: row.ProductId,
          ProductIdentityId: row.ProductIdentityId,
          count: row.sale_product_count,
          unitPrice: row.sale_product_price,
          unitDiscount: 0,
          property: JSON.parse(row.sale_product_property || "[]"),
        });
        added.push(row.sale_product_title);
      }
    });

    if (added.length)
      showToast(`کالاهای «${added.join("، ")}» از سفارش قبلی اضافه شد`, "info");
  }, [addCard, cart]);
};
